@if (labelType === InputLabelOptions.STATIC && textContent) {
<div class="d-flex gap-1 align-items-center">
  <span class="labelText labelIdle labelConfig"> {{ textContent }} </span>
</div>
}
<div
  appAccountDropdown
  (selectionChanged)="onAccountSelection($event)"
  (dropdownOpened)="onToggleDropdown($event)"
  [dropdownListing]="dropdownListing"
  [dropdownTemplate]="dropdownTemplate"
  [showFlag]="showFlag"
  [isScrollable]="isScrollable"
  [isScrollPeekEnabled]="isScrollPeekEnabled"
  [visibleItemsCount]="visibleItemsCount"
  [dropdownMenuDirection]="dropdownMenuDirection"
  [ngStyle]="currentInputStyle"
  [noRecordsTemplate]="noRecordsTemplate"
  [footerTemplate]="footerTemplate"
  [footerFloatingThreshold]="footerFloatingThreshold"
  (scrolled)="handleChildScroll()"
  class="d-flex h-100 accounts-context-dropdown is-space-between position-relative"
  [ngClass]="borderRadiusClass"
>
  <div class="d-flex align-items-center w-100">
    <mat-icon
      [ngStyle]="leftIconStyle"
      class="left mr-2"
      *ngIf="leftIcon"
      svgIcon="{{ leftIcon }}"
    ></mat-icon>
    <div
      class="d-flex mr-2"
      *ngIf="selectedAccount && showFlag"
      [innerHTML]="
        !this.isMultiCurrencyAccountInfoType($any(selectedAccount))
          ? (getCountryFlag($any(selectedAccount?.currency)) | safeHtml)
          : ('' | safeHtml)
      "
    ></div>
    @if (labelType === InputLabelOptions.PLACEHOLDER) {
    <div *ngIf="!selectedAccount">{{ textContent }}</div>
    }
    <div class="w-100" *ngIf="selectedAccount" [innerHTML]="renderedContent | safeHtml"></div>
  </div>
  <span class="is-center">
    @if (rightIcon) {
    <mat-icon [ngStyle]="rightIconStyle" svgIcon="{{ rightIcon }}"></mat-icon>
    } @else {
    <mat-icon [ngStyle]="rightIconStyle" svgIcon="chevron-down"></mat-icon>
    }
  </span>
</div>
